import { leadFormApi } from "@/core/data/api";

export default async (values) => {
  return await leadFormApi.createLeadForm(values);
};
